// Definition and load of all routes for the system
import React from "react";
import { Route, Routes } from "react-router-dom";

// Auth
import { useAuth } from "hooks";
import Approved from "pages/Approved";
import Archived from "pages/Archived";
import Duplicated from "pages/Duplicated";
// Pages
import Homepage from "pages/Homepage";
import Info from "pages/Info";
import MyClaims from "pages/MyClaims";
import Paid from "pages/Paid";
import Rejected from "pages/Rejected";
import Support, { ClaimExplained, EULA, PrivacyPolicy, SupportExplained } from "pages/Support";
import TeamClaims from "pages/TeamClaims";
import Unassigned from "pages/Unassigned";

import OnHold from "pages/On-Hold";
// Custom
import PrivateRoute from "./PrivateRoute";
import {
  APPROVED,
  ARCHIVED,
  CLAIM_EXPLAINED,
  DUPLICATED,
  HOME,
  INFO,
  MY_CLAIMS,
  ON_HOLD,
  PAID,
  PRIVACY_POLICY,
  REJECTED,
  ROOT,
  SUPPORT,
  SUPPORT_EXPLAINED,
  TEAM_CLAIMS,
  TERMS_OF_USE,
  UNASSIGNED,
} from "./RouteConstants";

const ApplicationRoutes: React.FC = () => {
  const { user } = useAuth();
  const isAuth = !!user; // convert user object to boolean as private route expects a boolean prop

  return (
    <div>
      <Routes>
        {/* Authenticated routes */}
        <Route path={ROOT} element={<PrivateRoute access={isAuth} />}>
          <Route path={HOME} element={<Homepage />} />

          {/* Claims Routes */}
          <Route path={UNASSIGNED} element={<Unassigned />} />
          <Route path={TEAM_CLAIMS} element={<TeamClaims />} />
          <Route path={MY_CLAIMS} element={<MyClaims />} />
          <Route path={REJECTED} element={<Rejected />} />
          <Route path={DUPLICATED} element={<Duplicated />} />
          <Route path={APPROVED} element={<Approved />} />
          <Route path={ON_HOLD} element={<OnHold />} />
          <Route path={PAID} element={<Paid />} />
          <Route path={ARCHIVED} element={<Archived />} />

          {/* Misc Routes */}
          <Route path={SUPPORT} element={<Support />} />
          <Route path={PRIVACY_POLICY} element={<PrivacyPolicy />} />
          <Route path={TERMS_OF_USE} element={<EULA />} />
          <Route path={SUPPORT_EXPLAINED} element={<SupportExplained />} />
          <Route path={CLAIM_EXPLAINED} element={<ClaimExplained />} />
          <Route path={INFO} element={<Info />} />
        </Route>
      </Routes>
    </div>
  );
};

export default React.memo(ApplicationRoutes);
